<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import { computed, defineEmits, defineProps, watch } from 'vue'
import { useRouter } from 'vue-router'

const isMobile = useIsMobile()

const props = defineProps<{
  isVisible: boolean
}>()

const emit = defineEmits(['close'])

const router = useRouter()

const baseMenuItems = [
  { label: '대시보드', route: '/dashboard' },
  { label: '프로그램', route: '/program' },
  { label: '오픈 클래스', route: '/open-class' },
  { label: '멘토', route: '/mentor' },
  { label: '라이브 스트리밍/온라인 수업', route: '/online-class' },
  { label: '내 클래스', route: '/my-class' },
  { label: 'FAQ', route: '/faq' },
  { label: '내 계정', route: '/my' },
]

const menuItems = computed(() => {
  const items = [...baseMenuItems]
  if (isMobile.value) {
  }
  return items
})

const navigateTo = (route: string) => {
  router.push(route)
  emit('close')
}

// 메뉴가 열릴 때 body 스크롤 제어
watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  },
)
</script>

<template>
  <div v-if="props.isVisible" class="fullscreen-menu">
    <div class="menu-header">
      <img
        class="close-button svg-white"
        src="@/assets/svgs/close.svg"
        alt="close"
        @click="emit('close')"
      />
    </div>
    <div class="menu-content">
      <div
        v-for="(item, index) in menuItems"
        :key="index"
        class="menu-item title-lg white"
        :class="{
          active: router.currentRoute.value.path === item.route,
          'title-md': isMobile,
        }"
        @click="navigateTo(item.route)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.fullscreen-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--gray-900);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 60px 0;
  -webkit-overflow-scrolling: touch; /* iOS 스크롤 부드럽게 */
}

.menu-header {
  position: fixed;
  display: flex;
  justify-content: flex-end;
  top: 40px;
  right: 40px;
  z-index: 1001;
}

.close-button {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  cursor: pointer;
}

.menu-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  margin-top: 20px;
}

.menu-item {
  cursor: pointer;
  transition: color 0.3s;
}

.menu-item.active {
  color: var(--tint-500);
}

.menu-item:hover {
  color: #ccc;
}

@media (max-width: 1365px) {
  .fullscreen-menu {
    align-items: flex-start;
    padding: 60px 0;
  }

  .menu-header {
    top: 12px;
    right: 20px;
  }

  .close-button {
    width: 24px;
    height: 24px;
  }

  .menu-content {
    position: relative;
    top: 0;
    margin: 0 auto;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
}
</style>
